import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { PHONE, TEL } from "@/lib/config";
import { useContent } from "@/lib/ContentContext";

export const AnnouncementBar = () => {
  const { content } = useContent();
  const text = content.announcement || "Veteran-Owned • Licensed & Insured • Residential & Commercial";
  return (
    <div className="bg-[var(--navy)] text-white text-xs sm:text-sm" data-testid="announcement-bar">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3">
        <p className="overline text-[11px] sm:text-xs tracking-wider truncate">
          <span className="text-[var(--aqua)]">★</span> {text}
        </p>
        <a href={TEL} data-testid="announcement-phone"
           className="flex items-center gap-1.5 font-semibold whitespace-nowrap hover:text-[var(--aqua)] transition-colors">
          <Phone className="w-3.5 h-3.5" /> {PHONE}
        </a>
      </div>
    </div>
  );
};
